var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import Button from "@irati/ui/src/Button";
import { injectIntl } from "@irati/utils/lang";
import makeCSV from "@irati/utils/csv/makeCSV";
import medicalTracking from "@irati-tracking/medical";
import { getCsv } from "@irati/medical/services/medical";
var DownloadReport = /** @class */ (function (_super) {
    __extends(DownloadReport, _super);
    function DownloadReport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            download: null
        };
        _this.downloadCsv = function () {
            var _a = _this.props, tenant = _a.tenant, trackingEventName = _a.trackingEventName;
            medicalTracking.downloadReport(trackingEventName);
            var download = getCsv(tenant.uuid).then(function (data) {
                var fileName = tenant.subdomain + "-activation-report.csv";
                makeCSV(data, fileName);
            });
            _this.setState({ download: download });
        };
        return _this;
    }
    DownloadReport.prototype.render = function () {
        var download = this.state.download;
        var _a = this.props, children = _a.children, Comp = _a.Comp, full = _a.full, large = _a.large;
        return (React.createElement(Comp, { onClick: this.downloadCsv, full: full, large: large, load: download }, children));
    };
    DownloadReport.defaultProps = {
        Comp: Button
    };
    return DownloadReport;
}(Component));
export default injectIntl(DownloadReport);
